module.exports = __webpack_public_path__ + "static/media/tq9.ef868337.jpg";